module.exports = __webpack_public_path__ + "media/images/brussels_page/logo2-c99167dd69ec6d83e90f0a1557de5952.svg";